<script setup>
import { formatDatumKurz as datumKurz, formatUhrzeitKurz as uhrzeit } from '../lib/format.js'

const props = defineProps({
  match: { type: Object, required: true },
  modelValue: { type: String, default: 'heim' },   // 'heim' | 'auswaerts'
  kompakt: { type: Boolean, default: false },
  zeigeSwitch: { type: Boolean, default: true },
  formHeim: { type: Array, default: () => [] },
  formAuswaerts: { type: Array, default: () => [] },
  platzHeim: { type: Number, default: null },
  platzAuswaerts: { type: Number, default: null }
})
const emit = defineEmits(['update:modelValue'])

const liveText = m => m.spielUhrKurz === 'HT' ? 'Live HT' : (m.minute ? `Live ${m.minute}'` : 'Live')
</script>

<template>
  <div :class="['tm-sw-kopf', { 'tm-sw-kopf--kompakt': kompakt }]">
    <div class="tm-sw-match">
      <div class="tm-sw-match__seite">
        <img v-if="match.heimLogo" :src="match.heimLogo" class="tm-sw-match__logo" alt="" />
        <span v-if="!zeigeSwitch" class="tm-sw-name">{{ match.heim }}</span>
        <span v-if="platzHeim" class="tm-sw-platz">Platz {{ platzHeim }}</span>
          <span v-if="formHeim.length" class="tm-sw-form" title="Form: letzte 5 Spiele, rechts das neueste">
            <small class="tm-sw-form__label"></small>
            <i
              v-for="(e, i) in formHeim"
              :key="i"
              :class="['tm-sw-form__p', `tm-sw-form__p--${e}`, { 'tm-sw-form__p--neu': i === formHeim.length - 1 }]"
              :title="e"
            ></i>
          </span>
      </div>
      <div class="tm-sw-match__mitte">
        <template v-if="match.status !== 'geplant' && match.heimtore != null">
          <span class="tm-sw-match__haupt">{{ match.heimtore }} : {{ match.austore }}</span>
          <span v-if="match.status === 'live'" class="tm-sw-match__neben">{{ liveText(match) }}</span>
        </template>
        <template v-else>
          <span class="tm-sw-match__haupt">{{ uhrzeit(match.zeit) }}</span>
          <span class="tm-sw-match__neben">{{ datumKurz(match.zeit) }}</span>
        </template>
      </div>
      <div class="tm-sw-match__seite">
        <img v-if="match.auswaertsLogo" :src="match.auswaertsLogo" class="tm-sw-match__logo" alt="" />
        <span v-if="!zeigeSwitch" class="tm-sw-name">{{ match.auswaerts }}</span>
        <span v-if="platzAuswaerts" class="tm-sw-platz">Platz {{ platzAuswaerts }}</span>
        <span v-if="formAuswaerts.length" class="tm-sw-form" title="Form: letzte 5 Spiele, rechts das neueste">
          <small class="tm-sw-form__label"></small>
          <i
            v-for="(e, i) in formAuswaerts"
            :key="i"
            :class="['tm-sw-form__p', `tm-sw-form__p--${e}`, { 'tm-sw-form__p--neu': i === formAuswaerts.length - 1 }]"
            :title="e"
          ></i>
        </span>
      </div>
    </div>

    <div v-if="zeigeSwitch" class="tm-sw-switch" role="group" aria-label="Team wählen">
      <button type="button"
        :class="['tm-sw-switch__btn', { 'tm-sw-switch__btn--aktiv': modelValue === 'heim' }]"
        @click="emit('update:modelValue', 'heim')">{{ match.heim }}</button>
      <button type="button"
        :class="['tm-sw-switch__btn', { 'tm-sw-switch__btn--aktiv': modelValue === 'auswaerts' }]"
        @click="emit('update:modelValue', 'auswaerts')">{{ match.auswaerts }}</button>
    </div>
  </div>
</template>